import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const ConsumableQuantityEstimation = React.lazy(() => import('.'));

export const consumableQuantityEstimationRoutes = [
  new Route({
    path: 'consumable-quantity-estimation',
    element: ConsumableQuantityEstimation,
    children: [],
  }),
];
